module.exports = __webpack_public_path__ + "img/human_56.1173fb32.png";